<template>
  <v-main class="bottom-gradient">
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12 rounded-xl" rounded>
            <div class="pl-10 pr-10 pt-10 pb-10">
              <v-fade-transition>
                <v-img class="logo" src="@/assets/logo-color.svg" v-if="!typeMember"></v-img>
                <v-img class="logo" src="@/assets/logo-grey.svg" v-else></v-img>
              </v-fade-transition>
            </div>

            <div
              class="pb-2 text-center text-h5 font-weight-light"
              v-if="!typeMember"
            >ESPAÇO DA ACADEMIA</div>
            <div class="pb-2 text-center text-h5 font-weight-light" v-else>CHECK-IN DE AULAS</div>
            <!-- <v-card-subtitle>Entre com seu login e senha abaixo:</v-card-subtitle> -->
            <v-slide-y-transition>
              <v-form ref="form" @submit.prevent="submit(false)" v-model="valid" v-if="!typeMember">
                <v-card-text class="mb-0 pb-0">
                  <v-container>
                    <div>Acesso ao painel de configurações da academia:</div>
                  </v-container>
                  <v-text-field
                    autofocus
                    required
                    clearable
                    outlined
                    rounded
                    :rules="rules.loginRules"
                    label="Login"
                    id="login"
                    name="login"
                    prepend-icon="mdi-account"
                    type="text"
                    v-model="form.username"
                    @keypress.enter="submit(false)"
                  ></v-text-field>
                  <v-text-field
                    required
                    clearable
                    outlined
                    rounded
                    :rules="rules.passwordRules"
                    id="password"
                    label="Senha"
                    name="password"
                    prepend-icon="mdi-lock"
                    type="password"
                    v-model="form.password"
                    @keypress.enter="submit(false)"
                  ></v-text-field>
                </v-card-text>
              </v-form>
              <v-form ref="form" @submit.prevent="submit(true)" v-model="valid" v-else>
                <v-card-text class="mb-0 pb-0">
                  <!-- LOGIN ALUNO -->
                  <v-container>
                    <div>
                      Olá
                      <strong>aluno</strong>, seja bem-vindo ao check-in de
                      aula!
                    </div>
                  </v-container>
                  <v-text-field
                    autofocus
                    required
                    clearable
                    outlined
                    rounded
                    class="v-input"
                    :rules="rules.idPolinexMemberRules"
                    label="ID da academia"
                    pattern="\d*"
                    id="login"
                    name="login"
                    prepend-icon="mdi-identifier"
                    type="text"
                    v-model.number="form.member.idPolinex"
                    @keypress.enter="submit(true)"
                  ></v-text-field>
                  <v-text-field
                    required
                    clearable
                    outlined
                    rounded
                    pattern="\d*"
                    class="inputPrice"
                    :rules="rules.cpfMemberRules"
                    label="CPF"
                    id="password"
                    name="password"
                    prepend-icon="mdi-card-account-details"
                    type="text"
                    v-model="form.member.cpf"
                    @keypress.enter="submit(true)"
                  ></v-text-field>
                </v-card-text>
              </v-form>
            </v-slide-y-transition>
            <v-container class="pt-0 pl-15 pr-15">
              <v-btn
                block
                height="40"
                :loading="loading"
                color="primary"
                @click="submit()"
                class="pt-0 mt-0"
              >Entrar</v-btn>
            </v-container>
            <v-card-actions class="pb-2">
              <v-btn
                rounded
                outlined
                small
                color="primary"
                v-if="typeMember"
                @click="isMemberToggle(false)"
              >Login academia</v-btn>

              <v-btn
                rounded
                outlined
                small
                color="primary"
                v-if="!typeMember"
                @click="isMemberToggle(true)"
              >Login aluno</v-btn>
              <!-- <v-spacer></v-spacer> -->
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data: () => ({
    typeMember: true,
    loading: false,
    valid: true,
    rules: {
      passwordRules: [v => !!v || "O campo senha é obrigatório!"],
      loginRules: [v => !!v || "O campo login é obrigatório!"],
      cpfMemberRules: [
        v => !!v || "O campo CPF do aluno é obrigatório!",
        v => /^[0-9]+$/.test(v) || "Apenas números no CPF!"
      ],
      idPolinexMemberRules: [
        v => !!v || "O campo ID da academia é obrigatório!",
        v => /^[0-9]+$/.test(v) || "Apenas números no ID da academia!"
      ]
    },
    form: {
      username: "",
      password: "",
      member: {
        idPolinex: null,
        cpf: ""
      }
    }
  }),
  mounted() {
    this.ActionCheckIsMember();
    this.typeMember = this.isMember;

    console.log("Login mounted this.typeMember: ", this.typeMember);
    //this.typeMember = this.CheckIsMember();
  },
  methods: {
    ...mapActions("auth", ["ActionDoLogin"]),
    ...mapActions("auth", ["ActionSetIsMember"]),
    ...mapActions("auth", ["ActionCheckIsMember"]),
    ...mapActions("snackbar", ["ActionSetSnackbar"]),
    async CheckIsMember() {
      return await this.ActionCheckIsMember();
    },
    isMemberToggle(isMember) {
      this.ActionSetIsMember(isMember);
      this.typeMember = isMember;
    },
    async submit() {
      this.$refs.form.validate();
      if (!this.valid) return;

      if (!this.isMember) {
        this.loading = true;
        try {
          await this.ActionDoLogin(this.form);
          this.$router.push({ name: "home" });
        } catch (err) {
          this.loading = false;
        }
      } else {
        this.loading = true;
        try {
          await this.ActionDoLogin(this.form.member);
          this.$router.push({ name: "member" });
        } catch (err) {
          this.loading = false;
        }
      }
    }
  },
  computed: {
    ...mapGetters("auth", ["isMember"])
    // ...mapState("auth", ["isMember"]),
  }
};
</script>
<style scoped>
.bottom-gradient {
  background-image: linear-gradient(to top, #606c88, #3f4c6b);
}
#body {
  background-color: #3f4c6b;
}
</style>
